import { SSRProvider } from '@restart/ui/ssr';
export default SSRProvider;